var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getCurrentABTests } from "../abTesting";
import { getQueryParam } from "../utilities";
var currentCurrencyCode = window.currentCurrencyCode;
export function sendAddToCartEvent(sku, quantity, customEventDimensions, customItemDimensions) {
    var _a;
    gtag("event", "add_to_cart", __assign({ currency: sku.price.currencyCode, value: getSkuPrice(sku) * quantity, items: [createGAItem(sku, quantity, customItemDimensions)], euro_value_incl_tax: getSkuPriceInEuros(sku) * quantity, value_incl_tax: getSkuPriceIncludingTax(sku) * quantity, voucher_discount_applied: (_a = sku.price) === null || _a === void 0 ? void 0 : _a.voucherDiscountApplied }, customEventDimensions));
}
export function sendViewItemEvent(sku, customEventDimensions, customItemDimensions) {
    var _a;
    var quantity = 1;
    gtag("event", "view_item", __assign({ currency: sku.price.currencyCode, value: getSkuPrice(sku), items: [createGAItem(sku, quantity, customItemDimensions)], euro_value_incl_tax: getSkuPriceInEuros(sku) * quantity, value_incl_tax: getSkuPriceIncludingTax(sku) * quantity, voucher_discount_applied: (_a = sku.price) === null || _a === void 0 ? void 0 : _a.voucherDiscountApplied }, customEventDimensions));
}
export function sendViewCartEvent(cartItems) {
    if (cartItems.length > 0) {
        var items = cartItems.map(function (cartItem) {
            var sku = cartItem.sku, quantity = cartItem.quantity;
            return createGAItem(sku, quantity);
        });
        var value = cartItems.reduce(function (acc, cartItem) {
            var sku = cartItem.sku, quantity = cartItem.quantity;
            if (!sku || !sku.price)
                return acc;
            var skuPrice = getSkuPrice(sku);
            return acc + skuPrice * (quantity || 0);
        }, 0);
        gtag("event", "view_cart", {
            currency: currentCurrencyCode,
            value: value,
            items: items,
        });
    }
}
export function sendViewItemListEvent(id, name, items, customEventDimensions) {
    gtag("event", "view_item_list", __assign({ currency: currentCurrencyCode, item_list_id: id, item_list_name: name, items: items }, customEventDimensions));
}
export function sendSelectItemEvent(id, name, items, customEventDimensions) {
    gtag("event", "select_item", __assign({ currency: currentCurrencyCode, item_list_id: id, item_list_name: name, items: items }, customEventDimensions));
}
export function sendRemoveFromCartEvent(sku, quantity) {
    gtag("event", "remove_from_cart", {
        currency: sku.price.currencyCode,
        value: getSkuPrice(sku) * quantity,
        items: [createGAItem(sku, quantity)],
        euro_value_incl_tax: getSkuPriceInEuros(sku) * quantity,
        value_incl_tax: getSkuPriceIncludingTax(sku) * quantity,
    });
}
function getSkuPrice(sku) {
    var _a = sku.price, numericTotalExclTaxAfterDiscount = _a.numericTotalExclTaxAfterDiscount, numericTotalExclTax = _a.numericTotalExclTax;
    return numericTotalExclTaxAfterDiscount
        ? numericTotalExclTaxAfterDiscount
        : numericTotalExclTax;
}
function getSkuPriceInEuros(sku) {
    var _a = sku.price, eurValueForAnalytics = _a.eurValueForAnalytics, numericTotalInclTax = _a.numericTotalInclTax;
    return eurValueForAnalytics
        ? parseFloat(eurValueForAnalytics)
        : numericTotalInclTax;
}
function getSkuPriceIncludingTax(sku) {
    var _a = sku.price, numericTotalInclTaxAfterDiscount = _a.numericTotalInclTaxAfterDiscount, numericTotalInclTax = _a.numericTotalInclTax;
    return numericTotalInclTaxAfterDiscount
        ? numericTotalInclTaxAfterDiscount
        : numericTotalInclTax;
}
export function createGAItem(sku, quantity, customItemDimensions) {
    var _a;
    var categories = Array(5)
        .fill(undefined)
        .map(function (_, i) { var _a, _b, _c; return (_c = (_b = (_a = sku.warehouseCategoryEnglish) === null || _a === void 0 ? void 0 : _a.facetingNameList) === null || _b === void 0 ? void 0 : _b[i]) !== null && _c !== void 0 ? _c : undefined; });
    var variantAttributeNames = sku.attributes
        .filter(function (attribute) { return attribute === null || attribute === void 0 ? void 0 : attribute.variant; })
        .map(function (attribute) { return "".concat(attribute.title, " - ").concat(attribute.value); });
    // These properties are used for Google Ads Dynamic Remarketing https://support.google.com/google-ads/answer/7305793?hl=en
    var googleAdsProperties = {
        id: sku.productId,
        google_business_vertical: "retail",
    };
    var customDimensions = __assign(__assign({ euro_price_incl_tax: getSkuPriceInEuros(sku), price_incl_tax: getSkuPriceIncludingTax(sku) }, googleAdsProperties), customItemDimensions);
    return __assign({ item_id: sku.productId.toString(), item_name: sku.title, discount: (_a = sku.price.numericTotalDiscount) !== null && _a !== void 0 ? _a : undefined, item_brand: sku.brand.title, item_category: categories[0], item_category2: categories[1], item_category3: categories[2], item_category4: categories[3], item_category5: categories[4], item_variant: variantAttributeNames ? variantAttributeNames[0] : undefined, price: getSkuPrice(sku), quantity: quantity }, customDimensions);
}
export function getGtagItemFromProductTile(tile, index) {
    var _a, _b;
    var _c = tile.dataset, productId = _c.productId, name = _c.name, category = _c.category, price = _c.price, eurPrice = _c.eurPrice, discount = _c.discount, retailerId = _c.retailerId, retailerName = _c.retailerName;
    if (!productId)
        return;
    // For product lists, get the brand from the product tile to avoid creating another data attribute in the DOM
    var brand = (_a = tile.querySelector("[data-item-brand]")) === null || _a === void 0 ? void 0 : _a.textContent;
    // For carousel items, get the brand from the data attributes
    if (!brand)
        brand = (_b = tile.dataset) === null || _b === void 0 ? void 0 : _b.brand;
    var gtagItem = {
        item_id: productId,
        item_name: name,
        discount: discount,
        index: index,
        item_brand: brand,
        item_category: category,
        price: price,
    };
    // For Carousels, add the retailer information
    var customParams = {
        retailer_id: retailerId,
        retailer_name: retailerName,
        euro_price_incl_tax: eurPrice,
    };
    return __assign(__assign({}, gtagItem), customParams);
}
export function sendSelectContentEvent(contentType, value) {
    gtag("event", "select_content", {
        content_type: contentType,
        event_value: value,
    });
}
export function sendCustomEvent(name, value) {
    gtag("event", name, value);
}
export function sendSearchEvent(query) {
    gtag("event", "search", {
        search_term: query,
    });
}
export function initGAUserProperties() {
    var currentTests = getCurrentABTests();
    var abTestObject = {};
    currentTests.forEach(function (test, index) {
        var testName = "".concat(test.name, "_").concat(test.version);
        var testKey = "ab_test_".concat(index + 1);
        abTestObject[testKey] = "".concat(testName, "=").concat(test.segment);
    });
    var userSettings = {
        bot_information: window.botInformation,
        website_country: window.currentCountry,
        website_language: window.currentLang,
        website_currency: window.currentCurrencyCode,
        affiliate_id: getQueryParam("ac"),
        affiliate_subcode: getQueryParam("asc"),
    };
    for (var _i = 0, _a = Object.entries(abTestObject); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        userSettings[key] = value;
    }
    gtag("set", "user_properties", userSettings);
}
